import React, { ReactNode, useEffect } from 'react';
import {
  DefaultValues,
  FieldValues,
  useForm,
  UseFormMethods,
  UseFormOptions,
} from 'react-hook-form';
import { Grid } from '@mui/material';
import { AnyObjectSchema } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {
  FormationsPrimaryButton,
  FormationsGhostButton,
} from 'components/common/Buttons';
import {
  FormationsFormActions,
  FormationsFormContainer,
  FormationsFormContent,
} from './FormationsFormContainer';
import { FormationsFormData, IFormField } from './types';
import { renderField } from './fieldRefactor';

const emptyFn = () => Promise.resolve();
interface FormationsFormProps {
  onSubmit: (data: FormationsFormData) => Promise<void>;
  onCancel?: () => void | Promise<void>;
  defaultValues?: DefaultValues<FieldValues>;
  fields: IFormField[];
  saveButtonLabel?: string;
  cancelButtonLabel?: string;
  validationSchema?: AnyObjectSchema;
  onChange?: (data: FormationsFormData, formInstance: UseFormMethods) => void;
  useFormOptions?: UseFormOptions;
  renderActions?: (formInstance: UseFormMethods) => ReactNode;
  loading?: boolean;
}

export function FormationsForm({
  onSubmit,
  onCancel = emptyFn,
  defaultValues = {},
  fields,
  validationSchema = yup.object(),
  saveButtonLabel = 'Save',
  cancelButtonLabel = 'Cancel',
  onChange = () => null,
  useFormOptions = {},
  renderActions,
  loading = false,
}: FormationsFormProps) {
  const formInstance = useForm({
    defaultValues,
    resolver: yupResolver(validationSchema),
    ...useFormOptions,
  });
  const { handleSubmit, watch, getValues } = formInstance;
  useEffect(() => {
    onChange(getValues(), formInstance);
  }, [watch()]);

  return (
    <FormationsFormContainer>
      <form noValidate onSubmit={handleSubmit(onSubmit)}>
        <FormationsFormContent>
          {fields.map((field) => (
            <Grid item key={field.name} xs={12} sx={{ mb: 1 }}>
              {renderField(field, formInstance)}
            </Grid>
          ))}
        </FormationsFormContent>
        <FormationsFormActions>
          {renderActions == null ? (
            <>
              <FormationsGhostButton
                onClick={onCancel}
                data-testid="form-cancel-btn"
                disabled={loading}
                sx={{ mr: 2 }}
              >
                {cancelButtonLabel}
              </FormationsGhostButton>
              <FormationsPrimaryButton
                isLoading={loading}
                type="submit"
                data-testid="form-save-btn"
              >
                {saveButtonLabel}
              </FormationsPrimaryButton>
            </>
          ) : (
            renderActions(formInstance)
          )}
        </FormationsFormActions>
      </form>
    </FormationsFormContainer>
  );
}
